import { VERSIONE_BUILD } from './versione';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const config = require('../assets/config/config.json');

export const environment = {
  production: config.production,
  version: VERSIONE_BUILD, // aggiornata da publish-*.sh (scripts/aggiorna-versione.sh)
  restBaseUrl: config.apiBaseUrl,
  rows: 10,
  msalConfig: {
    auth: {
        clientId: 'c48d322a-3e02-4aa2-833d-df8c156c7f0b',
        authority: 'https://login.microsoftonline.com/678c2cfe-700c-487e-994f-d0d855fde333',
        redirectUri: "/"
    }
  },
  msalApiConfig: {
      scopes: ['user.read'],
      uri: 'https://graph.microsoft.com/v1.0/me'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
